import { ToastType } from '@components/Toast/Toast';
import { handleToast } from '@utils/utils';
import { produce } from 'solid-js/store';

import { fetchLaneSearchData } from './services';
import { setLaneSearchStore } from './store';
import { LaneSearchPayload } from './types';

export const getAllLaneSearchData = async (payload: LaneSearchPayload) => {
  setLaneSearchStore('isLoading', true);
  try {
    const data = await fetchLaneSearchData(payload);
    setLaneSearchStore(
      produce((draft) => {
        draft.laneSearch = data;
        draft.isLoading = false;
        draft.isError = false;
      }),
    );
  } catch (error) {
    handleToast(ToastType.Error, (error as Error).message);
    setLaneSearchStore(
      produce((draft) => {
        draft.isLoading = false;
        draft.isError = true;
      }),
    );
  }
};
